import React from 'react';
import { formatCurrency } from '../lib/capacityPlanningFormatters';

const Card = ({ title, value, tone = 'text-slate-100', subtitle }) => (
  <div className="rounded-xl border border-slate-800 bg-slate-900/80 px-4 py-3 shadow-sm">
    <p className="text-[11px] uppercase tracking-wide text-slate-400">{title}</p>
    <p className={`mt-1 text-xl font-semibold ${tone}`}>{value}</p>
    {subtitle ? <p className="mt-1 text-xs text-slate-500">{subtitle}</p> : null}
  </div>
);

const CapacityPlanningSummaryCards = ({ summary }) => {
  const rows = summary || {};
  return (
    <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-6">
      <Card title="Total Kandidat" value={rows.totalCandidates || 0} />
      <Card title="Critical" value={rows.criticalCandidates || 0} tone="text-red-300" />
      <Card title="Top Area Pressure" value={rows.topAreaPressure || '-'} tone="text-amber-300" />
      <Card title="Top ODP Pressure" value={rows.topOdpPressure || '-'} tone="text-orange-300" />
      <Card title="Aktivasi Tertahan" value={rows.blockedActivationEstimate || 0} tone="text-purple-300" />
      <Card title="Peluang Revenue" value={formatCurrency(rows.revenueOpportunityEstimate || 0)} tone="text-emerald-300" />
    </div>
  );
};

export default CapacityPlanningSummaryCards;
